import ApiRequest from "../index"

const footerRequest = {
    get: async data => ApiRequest.get(`/v2/lojinha/footer/list`),
    put: async data => ApiRequest.put(`/v2/lojinha/footer/update`, {...data}),
}

export default footerRequest